import { getTestId } from '@airtel/air-design-system';
export var defaultProps = Object.assign({
  title: 'Select device',
  radioButtons: [{
    id: '1',
    label: 'My device',
    value: 'MY_DEVICE'
  }, {
    id: '2',
    label: 'Other device',
    value: 'OTHER_DEVICE'
  }],
  checkedRadioId: '2'
}, getTestId('RadioGroupWidgetContainer'));